// src/pages/Home.jsx
import React from 'react';
import Hero from '../components/ContactHero';
import Address from '../components/Address';
import Intro from '../components/Intro';
import Footer from '../components/Footer';
import ContactForm from '../components/ContactForm';

function Contact() {
  return (
    <>
      {/* <Hero />  */}
      {/* <Intro />  */}
      <ContactForm />
      <Address />
      <Footer />
    </>
  );
}

export default Contact;
